import { useStyles } from "./ActionPlanIssueOrRCACell.styles";
import { IActionPlanIssueOrRCACell } from "./ActionPlanIssueOrRCACellInterfaces";
import RCAIcon from "pages/Corporate/RCA/images/rca_icon.svg";
import IssueIcon from "pages/Corporate/RCA/images/issue_icon.svg";
import { useTranslation } from "react-i18next";

const ActionPlanIssueOrRCACell = ({ actionPlan }: IActionPlanIssueOrRCACell) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <div className={classes.actionPlanTypeCellWrapper}>
            <img src={actionPlan.issue_id ? IssueIcon : RCAIcon} alt="Action plan type icon" />
            <span>{`${
                actionPlan.issue_id
                    ? `${t("rca.iss")}-${actionPlan?.issue?.display_number}`
                    : `${t("rca.rca")}-${actionPlan?.rca?.display_number}`
            }`}</span>
        </div>
    );
};

export default ActionPlanIssueOrRCACell;
